import m from "./index205.mjs";
import v from "./index212.mjs";
import s from "./index210.mjs";
function y(t, a) {
  v(2, arguments);
  var r = s(a);
  r % 7 === 0 && (r = r - 7);
  var o = 1, e = m(t), n = e.getUTCDay(), d = r % 7, f = (d + 7) % 7, i = (f < o ? 7 : 0) + r - n;
  return e.setUTCDate(e.getUTCDate() + i), e;
}
export {
  y as default
};
//# sourceMappingURL=index301.mjs.map
